import { getAlbumArchiveSrc } from '@/shared/lib';

export const downloadAlbum = async (albumID: string): Promise<void> => {
  const downloadLink = Object.assign(document.createElement('a'), {
    href: getAlbumArchiveSrc(albumID),
  });

  downloadLink.click();
};
